import { ThemeUIStyleObject } from "theme-ui";

export const linkCTAStyle: ThemeUIStyleObject = {
  position: "absolute",
  left: "0",
  top: "0",
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "center",
  paddingInline: [5, null, 0],
};
export const headingStyles: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "white",
  textAlign: "center",
  maxWidth: "width.0",
};
